import c from 'classnames';

import { PatientNoteEditor } from './PatientNoteEditor';

import styles from './PractitionerSection.module.css';

interface PractitionerSectionProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PractitionerSection = ({
  isOpen,
  onClose,
}: PractitionerSectionProps) => {
  return (
    <section className={c(styles.section, { [styles.open]: isOpen })}>
      <PatientNoteEditor onClose={onClose} />
    </section>
  );
};

export default PractitionerSection;
